import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useCallback, useEffect, useState } from "react";
import { Skeleton } from "@material-ui/lab";
import { styled } from "@material-ui/core/styles";
import { trim, formatCurrency } from "../../helpers";
import { useDispatch, useSelector } from "react-redux";
import {
	Box,
	Grid,
	Paper,
	Typography,
	Zoom,
	Stack,
	Button,
	Tooltip,
	Popper,
	FormControl,
	InputAdornment,
	InputLabel,
	OutlinedInput,
	Slider
} from "@material-ui/core";
import tipsIcon1 from "../../assets/icons/tips_light.png";
import tipsIcon2 from "../../assets/icons/tips_black.png";

import "./snowglobe.scss";
function Snowglobe({ theme }) {
	const tipsIcon = theme === "light" ? tipsIcon1 : tipsIcon2;
	const isSmallScreen = useMediaQuery("(max-width: 733px)"); // change to breakpoint query
	const isVerySmallScreen = useMediaQuery("(max-width: 420px)");

	const [amount, setAmount] = useState(1);
	const [rewardYield, setRewardYield] = useState(0.9);
	const [currentPrice, setCurrentPrice] = useState(10);
	const [futurePrice, setFuturePrice] = useState(100);
	const [silderVal, setSilderVal] = useState(1);

	const [anchorEl, setAnchorEl] = useState(null);
	const handleClick = event => {
		setAnchorEl(anchorEl ? null : event.currentTarget);
	};
	const open = Boolean(anchorEl);
	const id = "ohm-popper";

	const isAppLoading = useSelector(state => state.app.loading);
	const stakingRebase = useSelector(state => {
		return state.app.stakingRebase;
	});
	const sohmBalance = useSelector(state => {
		return state.account.balances && state.account.balances.sohm ? state.account.balances.sohm : 0;
	});
	const marketPrice = useSelector(state => {
		return state.app.marketPrice > 0 ? trim(state.app.marketPrice, 2) : 10;
	});
	const stakingRebasePercentage = stakingRebase > 0 ? trim(stakingRebase * 100, 4) : 0.9;

	const setMax = (name) => {
		if (name == 'amount') {
			setAmount(sohmBalance);
		} else if (name == 'rewardYield') {
			setRewardYield(stakingRebasePercentage);
		} else if (name == 'currentPrice') {
			setCurrentPrice(marketPrice);
		} else if (name == 'futurePrice') {
			setFuturePrice(marketPrice);
		} else {
			return;
		}
	};

	const handleSilderChange = (event, newValue) => {
		if (typeof newValue === 'number') {
			setSilderVal(newValue);
		}
	};

	return (
		<>
			<Zoom in={true}>
				<Paper className="ohm-card">
					<Box className="card-header">
						<Typography variant="h5">Estimate your returns (3, 3)</Typography>
					</Box>
					<Grid container item xs={12} className="header-container">
						<Grid item xs={12} sm={4} md={4} lg={4}>
							<Box display="flex" alignItems="center" flexDirection="column">
								<Typography variant="h6" color="textSecondary">
									Current ZENVO Price
								</Typography>
								<Typography variant="h4">
									{isAppLoading ? <Skeleton width="150px" /> : <>{`$${marketPrice}`}</>}
								</Typography>
							</Box>
						</Grid>

						<Grid item xs={12} sm={4} md={4} lg={4} style={{ marginTop: `${isVerySmallScreen ? "8px" : "0px"}` }}>
							<Box display="flex" alignItems="center" flexDirection="column">
								<Box display="flex" alignItems="center">
									<Typography variant="h6" color="textSecondary">
										Current Reward Yield
									</Typography>
									<img src={tipsIcon} style={{ wdth: "16px", height: "16px", marginLeft: "10px" }}
										onMouseEnter={e => handleClick(e)}
										onMouseLeave={e => handleClick(e)}
										id="ohm-menu-button-hover" ></img>
									<Popper id={id} open={open} anchorEl={anchorEl} placement="bottom-start" transition>
										<Paper className="ohm-menu" elevation={1}>
											<Typography variant="h6">
												The reward yield will change over time.
											</Typography>
										</Paper>
									</Popper>
								</Box>
								<Typography variant="h4">
									{isAppLoading ? <Skeleton width="150px" /> : <>{stakingRebasePercentage}%</>}
								</Typography>
							</Box>
						</Grid>

						<Grid item xs={12} sm={4} md={4} lg={4} style={{ marginTop: `${isVerySmallScreen ? "8px" : "0px"}` }}>
							<Box display="flex" alignItems="center" flexDirection="column">
								<Typography variant="h6" color="textSecondary">
									Your sZENVO Balance
								</Typography>
								<Typography variant="h4">
									{isAppLoading ? <Skeleton width="150px" /> : <>{trim(sohmBalance, 4)} ZENVO</>}
								</Typography>
							</Box>
						</Grid>
					</Grid>

					<Box display="flex" className="snowglobe-container">
						<Grid container item className="header-container">
							<Grid item xs={12} sm={7}>
								<Grid container item>
									<Grid item xs={9}>
										<FormControl className="ohm-input" variant="outlined" color="primary">
											<Box display="flex" justifyContent="center" className="form-label">
												<Typography variant="h6">
													sZENVO AMOUNT
												</Typography>
											</Box>
											<OutlinedInput
												id="outlined-adornment-amount"
												autoFocus={true}
												type="number"
												placeholder="Enter ZENVO Amount"
												className="snowglobe-input"
												value={amount}
												onChange={e => setAmount(e.target.value >= 10000 ? 10000 : e.target.value)}
												// startAdornment={<InputAdornment position="start">$</InputAdornment>}
												labelWidth={0}
												endAdornment={
													<InputAdornment position="end">
														<Button variant="text" onClick={() => { setMax('amount') }}>
															Max
														</Button>
													</InputAdornment>
												}
											/>
											<Box display="flex" justifyContent="center" className="form-label">
												<Typography variant="h6">
													REWARD YIELD (%)
												</Typography>
											</Box>
											<OutlinedInput
												id="outlined-adornment-reward"
												type="number"
												placeholder="Enter Reward Yield (%)"
												className="snowglobe-input"
												value={rewardYield}
												onChange={e => setRewardYield(e.target.value >= 100 ? 100 : e.target.value)}
												// startAdornment={<InputAdornment position="start">$</InputAdornment>}
												labelWidth={0}
												endAdornment={
													<InputAdornment position="end">
														<Button variant="text" onClick={() => { setMax('rewardYield') }}>
															CURRENT
														</Button>
													</InputAdornment>
												}
											/>
											<Box display="flex" justifyContent="center" className="form-label">
												<Typography variant="h6">
													ZENVO PRICE AT PURCHASE (USDC)
												</Typography>
											</Box>
											<OutlinedInput
												id="outlined-adornment-amount"
												type="number"
												placeholder="Enter buy price"
												className="snowglobe-input"
												value={currentPrice}
												onChange={e => setCurrentPrice(e.target.value >= 20000 ? 20000 : e.target.value)}
												// startAdornment={<InputAdornment position="start">$</InputAdornment>}
												labelWidth={0}
												endAdornment={
													<InputAdornment position="end">
														<Button variant="text" onClick={() => { setMax('currentPrice') }}>
															CURRENT
														</Button>
													</InputAdornment>
												}
											/>
											<Box display="flex" justifyContent="center" className="form-label">
												<Typography variant="h6">
													FUTURE ZENVO MARKET PRICE (USDC)
												</Typography>
											</Box>
											<OutlinedInput
												id="outlined-adornment-future"
												type="number"
												placeholder="Enter future price"
												className="snowglobe-input"
												value={futurePrice}
												onChange={e => setFuturePrice(e.target.value >= 20000 ? 20000 : e.target.value)}
												// startAdornment={<InputAdornment position="start">$</InputAdornment>}
												labelWidth={0}
												endAdornment={
													<InputAdornment position="end">
														<Button variant="text" onClick={() => { setMax('futurePrice') }}>
															CURRENT
														</Button>
													</InputAdornment>
												}
											/>
										</FormControl>
									</Grid>
									<Grid item xs={3} className="sliderContainer">
										<Box className="sliderDesc" display="flex" alignItems="center" flexDirection="column"
											style={{ marginTop: `${isVerySmallScreen ? "16px" : "8px"}` }}>
											<Typography variant="h6">
												{silderVal}
											</Typography>
											<Typography variant="h6">
												days
											</Typography>
										</Box>
										<Slider
											value={silderVal}
											min={1}
											step={1}
											max={365}
											color="#6f89d6"
											orientation="vertical"
											onChange={handleSilderChange}
											valueLabelDisplay="auto"
											aria-labelledby="non-linear-slider"
										/>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12} sm={5}>
								<Box className="info" display="flex" justifyContent="center" flexDirection="column">
									<Box display="flex" justifyContent="space-between" alignItems="center" className="info-item">
										<Typography variant="h6">
											Your initial investment
										</Typography>
										<Typography variant="h6">
											{trim(amount * currentPrice, 2)} USDC
										</Typography>
									</Box>
									<Box display="flex" justifyContent="space-between" alignItems="center" className="info-item">
										<Typography variant="h6">
											Current wealth
										</Typography>
										<Typography variant="h6">
											{trim(marketPrice, 2)} USDC
										</Typography>
									</Box>
									<Box display="flex" justifyContent="space-between" alignItems="center" className="info-item">
										<Typography variant="h6">
											ZENVO rewards estimation
										</Typography>
										<Typography variant="h6">
											{trim(amount * Math.pow((1 + rewardYield / 100), 3 * silderVal) - amount, 2).toString()} ZENVO
										</Typography>
									</Box>
									<Box display="flex" justifyContent="space-between" alignItems="center" className="info-item">
										<Typography variant="h6">
											Potential return
										</Typography>
										<Typography variant="h6">
											{trim(amount * Math.pow((1 + rewardYield / 100), 3 * silderVal) * futurePrice, 2).toString()} USDC
										</Typography>
									</Box>
									<Box display="flex" justifyContent="space-between" alignItems="center" className="info-item">
										<div>
											<Typography variant="h6">
												Potential number of lambos*
											</Typography>
											<Typography variant="h6" color="textSecondary">
												Lamborghini Huracán, no options
											</Typography>
										</div>
										<Typography variant="h6">
											{trim(amount * Math.pow((1 + rewardYield / 100), 3 * silderVal) * futurePrice / 200000, 2).toString()}
										</Typography>
									</Box>
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Paper>
			</Zoom>
		</>
	);
}

export default Snowglobe;